import type {
    TemplateCheckPayload,
    TemplateCheckResponse,
} from '@/types/apps/template-check.type';

import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';
import type { Deletable } from '@/types/service/deletable.interface';
import type { Indexable } from '@/types/service/indexable.interface';
import type { Showable } from '@/types/service/showable.interface';
import type { Updatable } from '@/types/service/updatable.interface';

export interface TemplateCheckServiceInterface {}

type TemplateCheckListResponse = ApiResponse<
    PaginatedResult<TemplateCheckResponse>
>;

export class TemplateCheckService
    implements Indexable, Showable, Creatable, Updatable, Deletable
{
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        templateCheck: {
            base: () => '/api/template-check',
            detail: (id: string) => `/api/template-check/${id}`,
        },
    };

    public index(params?: QueryParams): Promise<TemplateCheckListResponse> {
        return this.apiClient.fetchApi(
            this.endpoints.templateCheck.base(),
            params
        );
    }

    public detail(
        id: string,
        params?: QueryParams
    ): Promise<ApiResponse<TemplateCheckResponse>> {
        // URL đã bao gồm id
        const url = this.endpoints.templateCheck.detail(id);

        return this.apiClient.fetchApi<TemplateCheckResponse>(url, params);
    }

    public create(
        params: TemplateCheckPayload
    ): Promise<ApiResponse<TemplateCheckResponse>> {
        return this.apiClient.postApi(
            this.endpoints.templateCheck.base(),
            params
        );
    }

    public update(
        id: string,
        payload: TemplateCheckPayload
    ): Promise<ApiResponse<TemplateCheckResponse>> {
        const url = this.endpoints.templateCheck.detail(id);

        return this.apiClient.putApi(url, payload);
    }

    public destroy(
        ids: string[],
        isHardDeleted: boolean = false
    ): Promise<ApiResponse<void>> {
        const url = this.endpoints.templateCheck.base();

        return this.apiClient.destroyApi<void>(url, ids, isHardDeleted);
    }
}
